export const ShowMore = () => {
  $('.js-show-more').each(function () {
    const $this = $(this);
    const $wrap = $this.closest('.js-show-more-wrap');
    const $content = $wrap.find('.js-show-content');

    if ($content.height() > 130) {
      $this.show();
      $this.on('click', () => {
        $wrap.toggleClass('opened');
      })
    } else {
      $this.hide();
    }
  });
};
